import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { ThemeProvider } from './hooks';
import './index.css';

const SwitchupOperatingSystem = React.lazy(() => import('./swup-operating-system'));
const Backstage = React.lazy(() => import('./backstage'));
const Careers = React.lazy(() => import('./careers'));
const Insider = React.lazy(() => import('./insider'));
const PrivacyPolicy = React.lazy(() => import('./privacy'));

function ScrollToTop() {
    const { pathname, hash } = useLocation();
    React.useEffect(() => {
        if (hash) {
            const targetId = hash.replace('#', '');
            const target = document.getElementById(targetId);
            if (target) {
                target.scrollIntoView({ behavior: 'smooth', block: 'start' });
                return;
            }
        }
        window.scrollTo(0, 0);
    }, [pathname, hash]);
    return null;
}

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <ThemeProvider>
            <BrowserRouter>
                <ScrollToTop />
                <React.Suspense
                    fallback={
                        <div className="min-h-screen bg-terminal-bg text-primary font-mono flex items-center justify-center">
                            <span className="text-muted text-sm">Loading route...</span>
                        </div>
                    }
                >
                    <Routes>
                        <Route path="/" element={<SwitchupOperatingSystem />} />
                        <Route path="/backstage" element={<Backstage />} />
                        <Route path="/careers" element={<Careers />} />
                        <Route path="/insider" element={<Insider />} />
                        <Route path="/privacy" element={<PrivacyPolicy />} />
                    </Routes>
                </React.Suspense>
            </BrowserRouter>
        </ThemeProvider>
    </React.StrictMode>
);
